export const StudentAssignmentRequestedModelFields = [
  "id",
  "quiz_id",
  "lesson_id",
  "status",
  "type",
  "name",
  "description",
  "external_url",
  "settings",
  "complete_time",
  "is_paid_per_attempt",
  "product_id",
  "max_attempts",
  "starting_at",
  "starting_at_type",
  "ending_at",
  "ending_at_type",
  "is_straight_answer",
  "is_show_results_after_finished",
  "is_show_answers_after_finished",
  "is_points_method",
  "is_comments",
  "is_chat",
  "is_certificate",
  "is_proctoring",
  "is_webinar",
  "is_started",
  "is_finished",
  "is_registered",
  "application",
  "proctoring_policy_agree",
  "head_identity_manual_disabled",
  "head_tracking_manual_disabled",
  "main_camera_manual_disabled",
  "second_camera_manual_disabled",
  "screen_share_manual_disabled",
  "fullscreen_mode_manual_disabled",
  "displays_check_manual_disabled",
  "read_clipboard_manual_disabled",
  "focus_detector_manual_disabled",
  "extension_detector_manual_disabled",
  "noise_detector_manual_disabled",
  "head_identity_manual_enabled",
  "head_tracking_manual_enabled",
  "main_camera_manual_enabled",
  "second_camera_manual_enabled",
  "screen_share_manual_enabled",
  "fullscreen_mode_manual_enabled",
  "displays_check_manual_enabled",
  "read_clipboard_manual_enabled",
  "focus_detector_manual_enabled",
  "extension_detector_manual_enabled",
  "noise_detector_manual_enabled",
  "available_time",
  "student_assessments",
  "attempts",
  "results",
  "points",
  "max_points",
  "quizzes:id",
  "quizzes:name",
  "quizzes:description",
  "quizzes:additional",
  "quizzes:components",
  "quizzes:settings",
  "lessons:id",
  "lessons:name",
  "lessons:description",
  "lessons:settings",
  "lessons:chapters:id",
  "lessons:chapters:name",
  "lessons:chapters:description",
  "lessons:chapters:position",
  "lessons:chapters:components",
  "webinar:id",
  "webinar:chat_id",
  "webinar:server",
  "webinar:room",
  "webinar:token",
  "webinar:ice_servers",
  "chat_id",
  "hdcp_check_manual_disabled",
  "speech_detector_manual_disabled",
  "hdcp_check_manual_enabled",
  "speech_detector_manual_enabled",
  // Выданные документы: по ним прячется скачивание отозванного.
  // Singular — старая привязка задания одним бланком.
  "student_certificate",
  "student_certificates",
];

// Специальный набор полей только для manual proctoring settings
export const ManualProctoringRequestedModelFields = [
  "main_camera_manual_disabled",
  "second_camera_manual_disabled",
  "screen_share_manual_disabled",
  "head_identity_manual_disabled",
  "head_tracking_manual_disabled",
  "displays_check_manual_disabled",
  "hdcp_check_manual_disabled",
  "fullscreen_mode_manual_disabled",
  "read_clipboard_manual_disabled",
  "extension_detector_manual_disabled",
  "noise_detector_manual_disabled",
  "focus_detector_manual_disabled",
  "speech_detector_manual_disabled",
  "main_camera_manual_enabled",
  "second_camera_manual_enabled",
  "screen_share_manual_enabled",
  "head_identity_manual_enabled",
  "head_tracking_manual_enabled",
  "displays_check_manual_enabled",
  "hdcp_check_manual_enabled",
  "fullscreen_mode_manual_enabled",
  "read_clipboard_manual_enabled",
  "extension_detector_manual_enabled",
  "noise_detector_manual_enabled",
  "focus_detector_manual_enabled",
  "speech_detector_manual_enabled",
];

export const ManagerAssignmentRequestedModelFields = [
  "id",
  "external_id",
  "class_id",
  "owner_id",
  "lesson_id",
  "quiz_id",
  "webinar_id",
  "chat_id",
  "invite_code_id",
  "product_id",
  "certificate_id",
  "external_url",
  "status",
  "type",
  "access_type",
  "name",
  "description",
  "complete_time",
  "max_attempts",
  "is_paid_per_attempt",
  "points_method_type",
  "settings",
  "starting_at",
  "starting_at_type",
  "ending_at",
  "ending_at_type",
  "observer",
  "application",
  "is_points_method",
  "is_straight_answer",
  "is_show_answers_after_finished",
  "is_show_results_after_finished",
  "is_hide_users",
  "is_comments",
  "is_chat",
  "is_invite_code",
  "is_certificate",
  "is_proctoring",
  "is_webinar",
  "is_public",
  "is_unlisted",
  "is_random_assessment",
  "progress",
  "owner",
  "invite_code",
  "class:id",
  "class:name",
  "class:description",
  "class:image",
  "class:color",
  "quizzes:id",
  "quizzes:name",
  "quizzes:question_count",
  "quizzes:description",
  "quizzes:image",
  "quizzes:color",
  "lessons:id",
  "lessons:name",
  "lessons:description",
  "lessons:image",
  "lessons:color",
  "reviewers:id",
  "reviewers:photo",
  "reviewers:firstname",
  "reviewers:lastname",
  "rooms:id",
  "rooms:name",
  "rooms:description",
  "rooms:image",
  "rooms:color",
  "rooms:pcs_count",
  "invite_code",
  "product",
  "webinars:id",
  "webinar:id",
  "webinar:status",
  "webinar:name",
  "webinar:description",
  "webinar:room",
  "webinar:token",
  "webinar:is_moderator",
  "webinar:server",
  "webinar:class:id",
  "webinar:class:name",
  "webinar:class:description",
  "webinar:ice_servers",
  "students_statistics",
  "max_points",
  "created_at",
];

/**
 * Safe variant of manager assignment fields for compatibility with backend:
 * some assignment types (e.g. `type=external`) may 500 when requesting `max_points`.
 */
export const ManagerAssignmentRequestedModelFieldsSafe =
  ManagerAssignmentRequestedModelFields.filter((f) => f !== "max_points");

export const AssignmentAttemptDetailRequestedModelFields = [
  "student_assessments",
  "attempts",
  "actions",
  "violations",
  "identities",
  "credibility",
  "credibility_verdict",
  "results_chart",
  "is_started",
  "is_finished",
  "available_time",
  "progress",
  "quiz_components",
  "webinar_sessions",
  "webinar_records",
  "audio_transcriptions",
  "student_certificate",
  // Документы по всем бланкам задания; singular — для старой привязки одним бланком
  "student_certificates",
];

/**
 * Окружение попытки: /assignment-attempts?id=…
 *
 * Поля окружения лежат в extended-наборе модели, а заголовок задаёт список
 * целиком — поэтому их надо называть вложенно. Просто «environment» вернёт
 * дефолтные поля связи, то есть четыре идентификатора и ничего больше.
 */
export const AttemptEnvironmentRequestedModelFields = [
  "id",
  "environment:data",
  "environment:processes",
  "environment:connections",
  "environment:report",
];

export const WebinarSessionsRequestedModelFields = [
  "id",
  "webinar_id",
  "user_id",
  "type",
  "status",
  "state",
  "session_type",
  "record",
  "created_at",
];

export const GetAssignmentsAsManagerRequestedModelFields = [
  "id",
  "status",
  "is_started",
  "is_finished",
  "progress",
  "type",
  "name",
  "description",
  "lesson:name",
  "quiz:name",
  "class:name",
  "owner:firstname",
  "owner:lastname",
  "students_count",
  "starting_at",
  "starting_at_type",
  "ending_at",
  "ending_at_type",
  // Новые поля для платного доступа
  "access_type",
  "product_id",
  "product:id",
  "product:name",
  "product:price",
  "product:currency_id",
  "product:formatted_price",
  "product:is_acquired",
  "product:payment_type",
  "product:shipment_type",
  "product:image",
  "is_proctoring",
  "settings",
];

export const GetAssignmentActionsRequestedModelFields = [
  "id",
  "assignment_id",
  "student_id",
  "webinar_session_id",
  "action_type",
  "description",
  "screenshot",
  "is_warning",
  "created_at",
  "user:id",
  "user:firstname",
  "user:lastname",
];
